import React, { useState, useEffect, useContext } from "react"
import { Typography, Grid, Stack, Box, Divider } from "@mui/material"
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone"
import ChatTwoToneIcon from "@mui/icons-material/ChatTwoTone"
import BackdropContext from "../../../context/BackdropContext"
import StateContext from "../../../context/StateContext"
import CurrentChatDesktop from "./CurrentChatDesktop"

const ChatDesktop = ({ setSnackbarMsg }) => {
  const { backdropOpen, openBackdrop, closeBackdrop } = useContext(BackdropContext)
  const [currentChat, setCurrentChat] = useState(null)

  const { ledgerList, ledgerLoading } = useContext(StateContext)
  const chats = ledgerList.filter((e) => e.status === "matched" || e.status === "finished")

  const loading = ledgerLoading

  useEffect(() => {
    if (loading) {
      openBackdrop()
    } else {
      if (backdropOpen) {
        closeBackdrop()
      }
    }
  }, [loading, openBackdrop, backdropOpen, closeBackdrop])

  return (
    <>
      <Grid container justifyContent="space-evenly" sx={{ height: "100%" }}>
        <Grid item xs={2.9}>
          <Box
            sx={{
              pl: 1,
            }}>
            <Typography variant="h5" sx={{ lineHeight: "8vh", color: "secondary.main" }}>
              Chat
            </Typography>
          </Box>
          <Stack>
            <Divider flexItem />
            {chats.map((chat) => (
              <Box
                key={chat.id}
                sx={{
                  cursor: "default",
                  height: "6vh",
                  lineHeight: "6vh",
                  px: 1,
                  my: "1vh",
                  borderTopRightRadius: "38px",
                  borderBottomRightRadius: "38px",
                  color: chat.status === "matched" ? "inherit" : "grey",
                  // textDecoration: c?.CID === currentChat?.CID ? "underline" : "inherit",
                  backgroundColor: chat.id === currentChat?.id ? "#ebebeb" : "inherit",
                  overflow: "hidden",
                }}
                onClick={() => setCurrentChat(chat)}>
                {chat.status === "matched" ? (
                  <ChatTwoToneIcon sx={{ color: "primary.main", verticalAlign: "middle", mr: 1 }} />
                ) : (
                  <CheckBoxTwoToneIcon sx={{ color: "inherit", verticalAlign: "middle", mr: 1 }} />
                )}
                {chat.book.title}
              </Box>
            ))}
          </Stack>
        </Grid>
        <Grid item xs>
          <Divider orientation="vertical" sx={{ borderColor: "primary.main" }} />
        </Grid>
        <Grid item xs={8.9} sx={{ px: 2 }}>
          {currentChat && <CurrentChatDesktop currentChat={currentChat} setCurrentChat={setCurrentChat} setSnackbarMsg={setSnackbarMsg} />}
        </Grid>
      </Grid>
    </>
  )
}

export default ChatDesktop
